<template>
    <div class="collapsing-filter-group" :class="{ 'collapsing-filter-group--active': isActive }">
        <a 
            :id="dropdownId + '-label'"
            href="#"
            class="collapsing-filter-group__trigger"
            :aria-title="`Open Filter Group for ${label}`"
            :title="`Open Filter Group for ${label}`"
            :aria-expanded="isActive"
            :aria-controls="dropdownId"
            role="button"
            @click.prevent="toggleOpen">

            <h4 class="collapsing-filter-group__label">{{label}}</h4>

            <div class="collapsing-filter-group__trigger__end">
                <template v-if="badgeText">
                    <div class="collapsing-filter-group__badge">{{badgeText}}</div>
                </template>
                <i class="fas fa-caret-down"></i>
            </div>

        </a>
        <div 
            :id="dropdownId"
            class="collapsing-filter-group__content"
            :class="{ 'd-none': isOpen == -1 }"
            :aria-labeledby="dropdownId + '-label'"
            role="region">
                <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        extraClasses: {
            type: String
        },
        dropdownId: {
            type: String,
            default: 'rw-filter-dropdown-' + Date.now() // better to pass an ID in instead of relying on this
        },
        label: {
            type: String,
            default: ''
        },
        isActive: {
            type: Boolean,
            default: false
        },
        badgeText: {}
    },
    data(){
        return {
            isOpen: -1
        }
    },
    mounted(){
        setTimeout(() => {
            // if the filter is mounted as active, open it
            // the timeout gives getters which power the isActive prop time to get 
            if(this.isActive) this.toggleOpen();
        }, 10);
    },
    methods: {
        toggleOpen() {
            this.isOpen *= -1;
        }
    },
    watch: {
        isActive(){
            // console.log('');
            // console.log('Collapser isActive chnged: ', this.label);
            // console.log(this.isActive);
            // console.log('');
            
        }
    }
}
</script>

<style>

</style>
